export default __webpack_public_path__ + "static/media/43.00a41ae9.png";